<template>
  <div>
    <v-row no-gutters v-if="locationData">
      <v-col md="6" sm="12" class="pa-0 ma-0">
        <v-card>
          <location-name-modal :action="submit" :alertScheduleTask="tasksScheduled" />
          <v-list-item>
            <v-list-item-content>
              <template v-if="!isEditingPrimaryCategory && !isEditingAdditionalCategories">
                <v-list-item-title>
                  {{ (locationData && locationData.primary_category && locationData.primary_category.display_name) || 'Sem categoria primária' }}
                </v-list-item-title>
                <v-list-item-title v-for="category in (locationData.categories || [])" :key="category.id">
                  {{ category.display_name }}
                </v-list-item-title>
                <v-btn small outlined color="primary" @click="onEditPrimaryCategory">
                  Editar Categoria Primária
                </v-btn>
                <v-btn small outlined color="primary" @click="onEditAdditionalCategories">
                  Editar Categoria Secundária
                </v-btn>
              </template>

              <template v-else-if="isEditingPrimaryCategory">
                <v-autocomplete v-model="primaryCategoryId" :search-input.sync="primarySearch" :items="categoryOptions"
                  item-text="display_name" item-value="category_id" label="Procurar e selecionar categoria primária"
                  clearable @input="fetchCategories(primarySearch)"
                />
                <v-btn small color="primary" @click="savePrimaryCategory">
                  Salvar Categoria primária
                </v-btn>
                <v-btn small text color="secondary" @click="cancelPrimaryCategoryEdit">
                  Cancelar
                </v-btn>
              </template>

              <template v-else-if="isEditingAdditionalCategories">
                <v-autocomplete v-model="selectedCategories" :search-input.sync="searchCategory" :items="categoryOptions"
                  item-text="display_name" item-value="id" menu-props="auto" label="Procurar e selecionar categorias adicionais"
                  multiple chips clearable @input="fetchCategories(searchCategory)"
                />
                <v-btn small color="primary" @click="saveAdditionalCategories">
                  Salvar Categorias Adicionais
                </v-btn>
                <v-btn small text color="secondary" @click="cancelAdditionalCategoriesEdit">
                  Cancelar
                </v-btn>
              </template>
            </v-list-item-content>
          </v-list-item>
          <v-divider />

          <div v-if="locationData">
            <location-code-modal :action="submit" :alertScheduleTask="tasksScheduled" />
            <location-address-modal :action="submit" :alertScheduleTask="tasksScheduled" />
            <location-description-modal :action="submit" :alertScheduleTask="tasksScheduled" />
            <location-phone-modal :action="submit" :alertScheduleTask="tasksScheduled" />
            <location-site-modal :action="submit" :alertScheduleTask="tasksScheduled" />
            <location-labels-modal :action="submit" :alertScheduleTask="tasksScheduled" />
            <location-schedule-modal :action="submit" :alertScheduleTask="tasksScheduled" />
            <location-special-schedule-modal :action="submit" :alertScheduleTask="tasksScheduled" />
            <location-more-schedule-modal v-for="hourType in locationData.available_hour_types" :key="hourType.id"
              :title="hourType.localized_display_name" :hourType="hourType.hours_type_id"
              :hourValues=locationData.moreHours :action="submit" :alertScheduleTask="tasksScheduled" />
            <location-attributes-modal :action="submit" :alertScheduleTask="tasksScheduled" />
            <location-attribute-url-modal v-for="attr in locationData.available_url_attributes" :key="attr.id"
              :title="attr.display_name" :attribute-id="attr.attribute_id" :alertScheduleTask="tasksScheduled"
              :action="submit" :value="get(attr, 'current_value.pivot.url_values[0].uri')" />
          </div>
        </v-card>
      </v-col>

      <v-col md="6" sm="12" class="pa-0 ma-0 mt-md-0 pl-md-3">
        <v-card class="mb-3 pa-1 card-info">
          <v-btn text class="mr-1" color="primary" @click="googleSearch" :disabled="!hasGoogleSearchUrl()">
            <v-icon left dark>mdi-google</v-icon>
            Ver na pesquisa
          </v-btn>
          <v-btn text color="primary" @click="viewOnMaps" :disabled="!hasGoogleMapsUrl()">
            <v-icon left dark>mdi-google-maps</v-icon>
            Ver no Google Maps
          </v-btn>
        </v-card>

        <v-card>
          <v-card-title class="subtitle-2">
            <span v-if="locationData && locationData.status === 'OPEN'">Fechar esta empresa no Google</span><span v-else>Reabrir esta
              empresa no Google</span>
          </v-card-title>

          <v-card-text>
            <span v-if="locationData && locationData.status === 'OPEN'">Você pode marcar esta empresa como fechada de forma temporária
              ou permanente. Também é possível removê-la da sua conta.</span> Também é possível removê-la da sua conta.
          </v-card-text>

          <div class="pa-4 pt-0">
            <div v-if="locationData && locationData.status === 'OPEN'">
              <location-confirm-modal :action="(data) => submit({ ...data, status: 'CLOSED_TEMPORARILY' })"
                actionClass="mb-3" actionText="Marcar como temporariamente fechada"
                title="Marcar esta empresa como temporariamente fechada?"
                description="Você pode marcar esta empresa como aberta a qualquer momento." with-schedule :alertScheduleTask="tasksScheduled" />
              <br>
              <location-confirm-modal :action="(data) => submit({ ...data, status: 'CLOSED_PERMANENTLY' })"
                actionClass="mb-3" actionText="Marcar como permanentemente fechada"
                title="Marcar esta empresa como permanentemente fechada?" description="Empresas permanentemente fechadas aparecem no Google com visibilidade reduzida.
                  Você pode marcar esta empresa como aberta a qualquer momento." with-schedule :alertScheduleTask="tasksScheduled" />
              <br>
            </div>
            <div v-else>
              <location-confirm-modal :action="(data) => submit({ ...data, status: 'OPEN' })" actionClass="mb-3"
                actionText="Marcar como aberta" title="Marcar esta empresa como aberta?" with-schedule :alertScheduleTask="tasksScheduled" />
              <br>
            </div>
            <location-confirm-modal disabled :action="() => { }" actionClass="mb-3" actionText="Remover ficha"
              :title="locationData ? `Remover ${locationData.location_name} da sua conta?` : ''" actionColor="error" with-schedule>
              <p>As informações comerciais associadas ainda aparecerão no Google Maps, na Pesquisa Google e em outros
                lugares no Google. Se o seu negócio estiver fechado, primeiro você deverá marcá-lo como
                <a class="my-link" target="_blank"
                  href="https://support.google.com/business/answer/10417060">permanentemente fechado.</a>
              </p>

              <p>Você não poderá recuperar os dados dessa ficha se mudar de ideia. É possível <a class="my-link"
                  target="_blank" href="https://support.google.com/business/answer/3415281">transferir a propriedade</a>
                dela em vez de removê-la.</p>

              <p>Se você remover essa ficha da sua conta:</p>

              <ul>
                <li>Todo o conteúdo dela será excluído, incluindo suas fotos, postagens e vídeos</li>
                <li>Outros administradores não poderão acessá-la</li>
                <li>Os anúncios associados do Google AdWords Express ficarão inativos</li>
                <li>Todos os sites publicados com o Google Meu Negócio também serão tirados do ar e excluídos</li>
              </ul>
            </location-confirm-modal>
          </div>
        </v-card>


        <v-card class="mt-4">
          <v-card-title class="mb-0">
            Verificação de local no Google
          </v-card-title>

          <v-tabs v-model="verificationTab">
            <v-tab>
              Solicitar
            </v-tab>
            <v-tab>
              Confirmar
            </v-tab>
            <v-tab-item>
              <v-card-text>
                <v-select outlined label="Método" :items="options" v-model="verificationForm.method" item-value="id">
                </v-select>
                <v-text-field outlined label="Tipo" v-model="verificationForm.value"></v-text-field>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn outlined color="primary" @click="sendVerification" :loading="loadingVerification">Enviar</v-btn>
              </v-card-actions>

            </v-tab-item>

            <v-tab-item>
              <v-card-text>
                <v-data-table  hide-default-footer :headers="table.headers"
                  :loading="loadingVerificationTable"
                  :items="locationData && (locationData.verifications || [])" :items-per-page="10" :footer-props="{
                    'disable-items-per-page': true
                  }">
                  <template v-slot:item="{item}">
                      <tr @click="() => onRowClick(item)" 
                      :class="selectedId==item.id ? 'verification-selected' : ''">
                        <td class="text-start">{{ item.create_time_formatted}}</td>
                        <td class="text-start">{{ item.method}}</td>
                        <td class="text-start">{{ item.state }}</td>
                      </tr>
                  </template>
                </v-data-table>
              </v-card-text>
              <v-card-actions>
                <v-text-field outlined class="mr-2" v-model="pin" label="Pin" v-mask="pinMask" dense ></v-text-field>
                <v-btn outlined color="primary" class="margin-bottom"
                  :disabled="!selectedId || ((this.pin && this.pin.length != 6) || !this.pin)" @click="sendPin"
                  :loading="loadingPin">
                  Confirmar
                </v-btn>
              </v-card-actions>
            </v-tab-item>
          </v-tabs>
        </v-card>
      </v-col>
    </v-row>

    <v-snackbar v-model="snackbar.show" timeout="3000" :color="snackbar.color">
      {{ snackbar.text }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar.show = false">
          Ok
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import LocationNameModal from '@/views/Locations/Modals/LocationNameModal'
import LocationPhoneModal from '@/views/Locations/Modals/LocationPhoneModal'
import LocationSiteModal from '@/views/Locations/Modals/LocationSiteModal'
import LocationDescriptionModal from '@/views/Locations/Modals/LocationDescriptionModal'
import LocationAddressModal from '@/views/Locations/Modals/LocationAddressModal'
import LocationCodeModal from '@/views/Locations/Modals/LocationCodeModal'
import LocationScheduleModal from '@/views/Locations/Modals/LocationScheduleModal'
import LocationSpecialScheduleModal from '@/views/Locations/Modals/LocationSpecialScheduleModal'
import LocationMoreScheduleModal from '@/views/Locations/Modals/LocationMoreScheduleModal'
import LocationConfirmModal from '@/views/Locations/Modals/LocationConfirmModal'
import LocationAttributesModal from '@/views/Locations/Modals/LocationAttributesModal'
import LocationAttributeUrlModal from '@/views/Locations/Modals/LocationAttributeUrlModal'
import { handleResponseError } from '@/api/handleError'
import { get } from 'lodash'
import LocationLabelsModal from '@/views/Locations/Modals/LocationLabelsModal'
import { mapState } from 'vuex'
import { TYPE_UPDATE_LOCATION_OPEN_INFO } from "@/constants/tasks";
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import { debounce } from 'lodash';
const pinMask = createNumberMask({
  prefix: '',
  allowDecimal: false,
  includeThousandsSeparator: false,
  allowNegative: false,
  integerLimit: 6,
})

export default {
  name: 'LocationInfoTab',
  components: {
    LocationAddressModal,
    LocationPhoneModal,
    LocationNameModal,
    LocationSiteModal,
    LocationDescriptionModal,
    LocationCodeModal,
    LocationLabelsModal,
    LocationScheduleModal,
    LocationSpecialScheduleModal,
    LocationMoreScheduleModal,
    LocationConfirmModal,
    LocationAttributesModal,
    LocationAttributeUrlModal
  },
  computed: {
    ...mapState({
      location: state => state.locations.location
    }),
    get() {
      return get
    }
  },
  methods: {
    showNotification(message, color) {
      this.snackbar.text = message
      this.snackbar.show = true
      this.snackbar.color = color
    },
    hasTaskScheduled(tasks) {
      if (tasks && tasks.length > 0) {
        const tasksScheduled = tasks.map(task => task.data.schedule_type);
        this.tasksScheduled = tasksScheduled;
      }
    },
    async sendVerification() {
      let data = {
        method: this.verificationForm.method
      }

      if (this.verificationForm.method == 'EMAIL') {
        data.email_address = this.verificationForm.value
      }
      else
        if (this.verificationForm.method == 'ADDRESS') {
          data.mailer_contact = this.verificationForm.value
        }
        else
          if (this.verificationForm.method == 'PHONE_CALL') {
            data.phone_number = this.verificationForm.value
          }
          else
            if (this.verificationForm.method == 'SMS') {
              data.phone_number = this.verificationForm.value
            }
            else
              if (this.verificationForm.method == 'VETTED_PARTNER') {
                data.token = this.verificationForm.value
              }


      this.loadingVerification = true
      await this.$store.dispatch('locations/sendVerification', { id: this.locationData.id, data })
        .then(async () => {
          this.verificationTab = 1
          this.loadingVerificationTable = true;
          await this.$store.dispatch('locations/getLocation', this.locationData.id).catch((e) => {
            const message = handleResponseError(
              e,
              'Ocorreu um erro ao buscar o local.'
            );
            this.showNotification(message, 'red darken-2');
            this.loadingVerificationTable = false;
          });
          this.loadingVerificationTable = false;

          this.$store.dispatch("locations/getLocation", this.locationData.id)
          this.showNotification('Verificação enviada!', 'green darken-2')
        })
        .catch(e => {
          this.loadingVerification = false
          const message = handleResponseError(e, 'Ocorreu um erro ao solicitar a verificação.')
          this.showNotification(message, 'red darken-2')
        })
      this.loadingVerification = false

    },
    async sendPin() {
      if ((this.pin && this.pin.length != 6) || !this.pin) {
        this.showNotification("O Pin deve ter 6 caractéres.", "red darken-2")
        return
      }
      const data = {
        pin: this.pin
      }
      this.loadingPin = true
      await this.$store.dispatch('locations/confirmVerification', { data, id: this.locationData.id, verificationId: this.selectedId })
        .then(() => {
          this.$store.dispatch("locations/getLocation", this.locationData.id)
          this.showNotification('Pin enviado com sucesso!', 'green darken-2')
        })
        .catch(e => {

          this.loadingPin = false
          const message = handleResponseError(e, 'Ocorreu um erro ao enviar o Pin.')
          this.showNotification(message, 'red darken-2')
        })
      this.loadingPin = false
    },

    onRowClick(item) {
      this.selectedId = this.selectedId === item.id ? null : item.id
    },
    hasGoogleSearchUrl() {
      return !!(get(this.location, 'data.location_name') && get(this.location, 'data.address.full_address'))
    },
    hasGoogleMapsUrl() {
      return !!get(this.location, 'data.maps_url')
    },
    googleSearch() {
      window.open(`https://www.google.com/search?q=${get(this.location, 'data.location_name')} ${get(this.location, 'data.address.full_address')}`)
    },
    viewOnMaps() {
      window.open(get(this.location, 'data.maps_url'))
    },
    submit: async function (data) {
      try {
        const id = get(this.location, 'data.id')
        if(!data.schedule_type) {
          data.schedule_type = TYPE_UPDATE_LOCATION_OPEN_INFO
        }
        if (!id) {
          this.showNotification('Dados inválidos. Por favor recarregue a página', 'red darken-2')
          return
        }

        await this.$store.dispatch('locations/update', { id, data })
          .then(() => this.showNotification('Alterações salvas!', 'green darken-2'))
          .catch(e => {
            const message = handleResponseError(e, 'Ocorreu um erro ao enviar os dados.')
            this.showNotification(message, 'red darken-2')
          })
      } catch (e) {
        const message = handleResponseError(e, 'Ocorreu um erro ao enviar os dados.')
        this.showNotification(message, 'red darken-2')
      }
    },
    onCategoryKeyUp: debounce(function (search) {
      this.fetchCategories(search);
    }, 500),

    // New methods for primary and additional categories
    onEditPrimaryCategory() {
      this.isEditingPrimaryCategory = true;
      this.isEditingAdditionalCategories = false;
      this.fetchCategories('');
    },
    cancelPrimaryCategoryEdit() {
      this.isEditingPrimaryCategory = false;
      if (this.locationData && this.locationData.primary_category) {
        this.primaryCategoryId = this.locationData.primary_category.category_id;
      } else {
        this.primaryCategoryId = null;
      }
    },
    async savePrimaryCategory() {
      try {
        const payload = {
          primary_category_id: this.primaryCategoryId || null
        };
        await this.$store.dispatch('locations/update', {
          id: this.locationData.id,
          data: payload
        });
        this.showNotification('Primary category updated successfully!', 'green darken-2');
        this.isEditingPrimaryCategory = false;
      } catch (e) {
        const message = handleResponseError(e, 'Failed to update primary category.');
        this.showNotification(message, 'red darken-2');
      }
    },
    async fetchCategories(search) {
      this.loadingCategories = true;
      try {
        const response = await this.$store.dispatch('locations/getCategories', {
          limit: 10,
          search: search,
        });
        console.log(response);
        this.categoryOptions = response.data || [];
      } catch (e) {
        const message = handleResponseError(e, 'Error fetching categories.');
        this.showNotification(message, 'red darken-2');
      } finally {
        this.loadingCategories = false;
      }
    },
    onEditAdditionalCategories() {
      this.isEditingPrimaryCategory = false;
      this.isEditingAdditionalCategories = true;
      this.fetchCategories('');
    },
    cancelAdditionalCategoriesEdit() {
      this.isEditingAdditionalCategories = false;
      if (this.locationData && this.locationData.categories) {
        this.selectedCategories = this.locationData.categories.map(cat => cat.id);
      } else {
        this.selectedCategories = [];
      }
    },
    async saveAdditionalCategories() {
      try {
        const payload = {
          categories: this.selectedCategories
        };
        await this.$store.dispatch('locations/update', {
          id: this.locationData.id,
          data: payload
        });
        this.showNotification('Additional categories updated successfully!', 'green darken-2');
        this.isEditingAdditionalCategories = false;
      } catch (e) {
        const message = handleResponseError(e, 'Failed to update additional categories.');
        this.showNotification(message, 'red darken-2');
      }
    },
  },
  mounted() {
    if (this.location) {
      this.locationData = this.get(this.location, 'data')
    }

    if (this.locationData && this.locationData.categories) {
      this.selectedCategories = this.locationData.categories.map(cat => cat.id);
    }

    if (this.locationData && this.locationData.primary_category) {
      this.primaryCategoryId = this.locationData.primary_category.category_id;
    } else {
      this.primaryCategoryId = null;
    }

    this.hasTaskScheduled(this.locationData?.scheduledTasks || []);
    this.$store.dispatch("locations/getVerification", this.locationData?.id)
  },
  data() {
    return {
      pinMask,
      selectedId: null,
      pin: "",
      verificationForm: {
        method: "",
        value: ""
      },
      loadingVerification: false,
      loadingPin: false,
      options: [{ id: "EMAIL", text: "Email" }, { id: "ADDRESS", text: "Endereço" }, { id: "PHONE_CALL", text: "Telefone" }, { id: "SMS", text: "Mensagem" }, { id: "VETTED_PARTNER", text: "Parceiro" }],
      snackbar: {
        text: '',
        show: false,
        color: 'info',
      },
      table: {
        headers: [
          { text: 'Data', value: 'create_time_formatted', align: 'start' },
          { text: 'Método', value: 'method' },
          { text: 'Estado', value: 'state' },
        ],
      },
      locationData: null,
      tasksScheduled: null,
      verificationTab: 0,
      loadingVerificationTable: false,
      searchCategory: '', 
      categoryOptions: [],
      isEditingCategory: false,
      loadingCategories: false,
      primarySearch: '',
      isEditingPrimaryCategory: false,
      isEditingAdditionalCategories: false,
      primaryCategoryId: null,
      selectedCategories: []
    }
  },
  watch: {
    location(location) {
      this.locationData = this.get(location, 'data')
      this.hasTaskScheduled(this.locationData?.scheduledTasks || []);

      if (this.locationData && this.locationData.categories) {
        this.selectedCategories = this.locationData.categories.map(cat => cat.id);
      } else {
        this.selectedCategories = [];
      }

      if (this.locationData && this.locationData.primary_category) {
        this.primaryCategoryId = this.locationData.primary_category.category_id;
      } else {
        this.primaryCategoryId = null;
      }
    },
    primarySearch(search) {
      if (search) {
        this.onCategoryKeyUp(search);
      }
    },
    searchCategory(search) {
      if (search) {
        this.onCategoryKeyUp(search);
      }
    },
  }
}
</script>

<style scoped>
.my-link {
  text-decoration: none;
}

.my-link:hover {
  text-decoration: underline;
}

.card-info {
  margin-top: 12px;
}

@media screen and (min-width: 960px) {
  .card-info {
    margin-top: 0;
  }
}

.verification-selected{
  background-color: #eeeeee;
}
.margin-bottom{
  margin-bottom: 22px;
}
</style>